import { Enrollment, EnrollmentDto } from './Enrollment';
import { utilities } from 'utils/utilities';

export interface FormEnrollmentDto extends EnrollmentDto {
  formId: string;
  instructionsJson?: string;
}

export class FormEnrollment extends Enrollment {
  formId: string;
  instructionsJson?: string;
  readonly type: 'FormEnrollment' = 'FormEnrollment';

  constructor(id: string, formId: string, instructionsJson?: string) {
    super(id);
    this.formId = formId;
    this.instructionsJson = instructionsJson;
  }

  toDto(): FormEnrollmentDto {
    return {
      formId: this.formId,
      instructionsJson: this.instructionsJson,
      id: this.id,
      enrollmentType: this.type,
      dtoType: 'Models.Api.Dtos.FormEnrollmentDto',
      nodeInstanceId: this.nodeInstanceId,
      requiredSubmissionType: this.requiredSubmissionType,
      status: this.status,
      satisfiedAt: this.satisfiedAt,
    };
  }

  static fromDto(dto?: Partial<FormEnrollmentDto> | FormEnrollment | any): FormEnrollment {
    console.log("FormEnrollment DTO " + JSON.stringify(dto));
    if (!dto) {
      return new FormEnrollment(utilities.DEFAULT_GUID, utilities.DEFAULT_GUID);
    }

    if (dto instanceof FormEnrollment) {
      return dto;
    }

    const id = dto.id ?? utilities.DEFAULT_GUID;
    const formId = dto.formId ?? utilities.DEFAULT_GUID;
    return new FormEnrollment(id, formId, dto.instructionsJson);
  }
}

// Register factory to avoid Enrollment needing a hard import (prevents circular init issues)
Enrollment.register('FormEnrollment', (d?: any) => FormEnrollment.fromDto(d));
Enrollment.register('Models.Enrollments.FormEnrollment', (d?: any) => FormEnrollment.fromDto(d));
